import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import UserLoginHistoryListing from "../UserManagement/UserLoginHistoryListing";
import { VW_ROUTES } from "../../constants";
import { AppContext } from "../../context/AppContext";
import { useHistory } from "react-router-dom";
import PermissionWrapper from "../../layout/PermissionWrapper";
import { checkModuleGeneralPermission } from "../../helpers/helpers";

const UserLoginHistory = ({ location }) => {
  const history = useHistory();
  const params = new URLSearchParams(location?.search);
  const { lastRouteStates, userRoleDetails } = useContext(AppContext);
  const [viewPagePermission, setViewPagePermission] = useState(undefined);

  const onBackButtonClick = () => {
    const fromPath = params.get("from");
    history.replace(
      _.has(lastRouteStates, fromPath)
        ? lastRouteStates[fromPath]
        : fromPath ?? VW_ROUTES.USERS
    );
  };

  useEffect(() => {
    if (!userRoleDetails) return;
    if (userRoleDetails?.isLoading) return;
    setViewPagePermission(
      checkModuleGeneralPermission(
        userRoleDetails,
        "user",
        "view_login_history",
        {}
      )
    );
  }, [userRoleDetails]);

  return (
    <PermissionWrapper
      isAllowed={viewPagePermission}
      isLoading={viewPagePermission === undefined}
    >
      <div className="page-header">
        <button
          type="button"
          className="btn btn-primary btn-sm float-right backArrow"
          onClick={() => onBackButtonClick()}
        >
          <span></span>
        </button>
        <h1>Login History - {_.startCase(params.get("name"))}</h1>
      </div>
      <UserLoginHistoryListing
        userId={params.get("id")}
        name={params.get("name")}
        from={params.get("from")}
        location={location}
      />
    </PermissionWrapper>
  );
};

export default UserLoginHistory;
